<template>
  <validation-observer id="percentual-perdas-aic" v-slot="{ valid }">
    <validation-helper :interceptor="valid" @isValid="$emit('stepReleased', $event)" />
    <v-row v-for="(percentual, i) in Object.entries(percentuais)" :key="i" class="mx-auto">
      <v-col class="cols-title pt-8 px-8" cols="6">
        <v-label>
          <strong>{{ percentual[1].label }}</strong>
        </v-label>
      </v-col>
      <v-col class="cols-percentage pb-0" cols="6">
        <validation-provider v-slot="{ errors }" rules="between:0,100">
          <v-text-field
            :value="percentual[1].perc"
            label="Percentual (%)"
            suffix="%"
            type="number"
            min="0"
            max="100"
            :error-messages="errors"
            @input="setPercentuais(percentual[0], 'perc', $event)"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </validation-observer>
</template>

<script>
  export default {
    components: {
      ValidationHelper: () => import('@/components/general/ValidationHelper.vue')
    },

    emits: ['stepReleased'],

    data: () => ({}),

    computed: {
      percentuais: {
        get() {
          return this.$store.state.perdasAic.percentuais;
        }
      }
    },

    methods: {
      setPercentuais(tipologia, key, value) {
        this.$store.dispatch('setPerdasAic', {
          percentuais: { [tipologia]: { [key]: value } }
        });
      },

      clearInputs(i, tipologia) {
        this.setPercentuais(tipologia, 'perc', '100');
      }
    }
  };
</script>
